import React from 'react';

const Columns = ({children}) =>
{
  return (
    <div className="utv-columns">
      {children}
    </div>
  );
}

export default Columns;
